import { Map } from '@popety_io/popety-io-lib'
import { API_BASE_URL } from '../../../../../services'

const renderMethod = 'aggs'

const sourceName = 'es_mvt_population'
const fillStyle = 'layer_fill_population'

const removePopulationTiles = ({ map }: { map: Map }) => {
  if (map.getSource(sourceName)) {
    map.removeLayer(fillStyle)
    map.removeSource(sourceName)
  }
}

const getPopulationTiles = ({
  map,
  indexName = 'statistics-point-population-year',
  fieldOpt = 'total_population',
  geometryFieldName = 'geo_center',
}: {
  map: Map
  indexName?: string
  geometryFieldName?: string
  fieldOpt?: string
}) => {
  try {
    if (map.getSource(sourceName)) {
      map.removeLayer(fillStyle)
      map.removeSource(sourceName)
    }

    map.addSource(sourceName, {
      type: 'vector',
      tiles: [
        `${API_BASE_URL}/public/population/tiles?index=${indexName}&geometry=${geometryFieldName}&fieldOpt=${fieldOpt}&renderMethod=${renderMethod}&x={x}&y={y}&z={z}`,
      ],
      minzoom: 0,
      maxzoom: 24,
    })

    map.addLayer({
      id: fillStyle,
      type: 'fill',
      source: sourceName,
      'source-layer': 'hits',
      paint: {
        'fill-outline-color': 'rgba(0, 0, 0, 0.5)',
        'fill-opacity': 0.5,
      },
    })

    let colorExpression: any = {
      property: fieldOpt,
      default: '#f0f0f0',
      stops: [
        [0, '#C5D564'],
        [60, '#DAD14C'],
        [130, '#EECD34'],
        [200, '#FCC423'],
        [300, '#F9891A'],
        [400, '#F14C11'],
      ],
    }

    if (fieldOpt === 'total_population_most_represented_age') {
      colorExpression = {
        property: fieldOpt,
        default: '#f0f0f0',
        type: 'categorical',
        stops: [
          ['total_population_0_19', '#C5D564'],
          ['total_population_20_39', '#DAD14C'],
          ['total_population_40_64', '#FCC423'],
          ['total_population_65_79', '#F9891A'],
          ['total_population_80_plus', '#F14C11'],
        ],
      }
    }

    if (fieldOpt === 'total_population_most_represented_households_number') {
      colorExpression = {
        property: fieldOpt,
        default: '#f0f0f0',
        type: 'categorical',
        stops: [
          ['total_households_1', '#C5D564'],
          ['total_households_2', '#DAD14C'],
          ['total_households_3', '#EECD34'],
          ['total_households_4', '#FCC423'],
          ['total_households_5', '#F9891A'],
          ['total_households_6_plus', '#F14C11'],
        ],
      }
    }

    if (fieldOpt === 'total_population_most_represented_residents_city_time') {
      colorExpression = {
        property: fieldOpt,
        default: '#f0f0f0',
        type: 'categorical',
        stops: [
          ['number_residents_city_0_1_year', '#C5D564'],
          ['number_residents_city_1_5_year', '#EECD34'],
          ['number_residents_city_6_10_year', '#F9891A'],
          ['number_residents_city_10_plus_year', '#F14C11'],
        ],
      }
    }

    if (fieldOpt === 'number_residents_city_0_1_year') {
      colorExpression = {
        property: fieldOpt,
        default: '#f0f0f0',
        stops: [
          [0, '#C5D564'],
          [10, '#DAD14C'],
          [30, '#EECD34'],
          [60, '#FCC423'],
          [90, '#F9891A'],
          [150, '#F14C11'],
        ],
      }
    }
    // Change the color
    map.setPaintProperty(fillStyle, 'fill-color', colorExpression)
  } catch (error) {
    console.error(error)
  }
}

export { removePopulationTiles, getPopulationTiles }
